import { initEditor, queryList, removeEditor, copyEditor, saveEditorInfo } from '@/api/editor/editor'

const state = {
  checkSceneInfo: {},
  sceneList: [],
  showSceneListDrawer: false,
  showSceneEdit: 'close',
  show3dEditor: false,
  showOpenModelChoose: false,
  treeData: [],
  treeDataMap: {},
  editorChooseModelArr: [],
  cameraPositionList: []
}

const actions = {
  async setSceneInfo({ commit }, scene) {
    commit('SET_SCENE_INFO', scene)
  },
  async copyScene({ dispatch }, id) {
    await copyEditor(id)
    dispatch('refreshSceneList', this.state.courseAndProject.course)
  },
  async removeScene({ commit, state }, editorData) {
    const index = state.sceneList.findIndex(item => item._id === editorData._id)
    removeEditor(editorData._id).then(() => {
      commit('REMOVE_SCENE', index)
    })
  },
  async reverseShowSceneEdit({ commit }, status) {
    commit('REVERSE_SHOW_SCENE_EDIT', status)
  },
  async reverseShowOpenModelChoose({ commit }, status) {
    commit('REVERSE_OPEN_MODEL_CHOOSE', status)
  },
  async refreshSceneList({ commit }, course) {

    if (!course._id) {
      return;
    }
    const sceneListRes = await queryList(course._id)
    if (sceneListRes.code == 200) {
      commit('SET_SCENE_LIST', sceneListRes.data.reverse())
    }
  },
  async checkEditor({ commit }, sceneInfo) {
    commit('SET_SCENE_INFO', sceneInfo)
    commit('SET_3D_EDITOR_STATUS', true);
  },
  async initEditor({ commit,dispatch }, data) {
    if (!data._id) {
      data.project = this.state.courseAndProject.project._id
      data.course = this.state.courseAndProject.course._id
      const res = await initEditor(data)
      commit('PUSH_SCENE_LIST', {
        _id: res.data,
        project: this.state.courseAndProject.project._id,
        course:this.state.courseAndProject.course._id,
        ...data
      })
      this.dispatch('task/setTaskEditor', res.data)
    } else {
      await saveEditorInfo(data)
      dispatch('refreshSceneList', this.state.courseAndProject.course)
    }
    commit('REVERSE_SHOW_SCENE_EDIT', 'close');
  },
  async closeEditor({ commit }) {
    commit('SET_3D_EDITOR_STATUS', false);
  },
  async reverse3DEditorStatus({ commit }, status) {
    commit('SET_3D_EDITOR_STATUS', status)
  },
  async reverseDrawerStatus({ commit }, status) {
    commit('SET_DRAW_STATUS', status)
  },
  async setTreeData({ commit }, treeData) {
    commit('SET_TREE_DATA', treeData);
    const castTreeMap = (node, map = {}, arr = []) => {
      let { id, name, children } = node;
      let newArr = [].concat(arr).concat(name);
      map[id] = {id, name, targetPath: newArr.join('/')};
      children.forEach(element => {
        castTreeMap(element, map, newArr)
      });
      return map;
    };

    const treeDataMap = treeData.reduce((pre, next) => {
      pre = castTreeMap(next, pre)
      return pre;
    }, {});
    commit('SET_TREE_DATA_MAP', treeDataMap);
  },
  async setEditorChooseModelArr({ commit }, arr) {
    commit('SET_EDITOR_CHOOSE_MODEL_ARR', arr);
  },
  async setEditorPositionList({commit}, list) {
    commit('SET_CAMERA_POSITION_LIST', list);
  }
}

const mutations = {
  REMOVE_SCENE(state, index) {
    state.sceneList.splice(index, 1);
  },
  REVERSE_OPEN_MODEL_CHOOSE(state, status) {
    state.showOpenModelChoose = status;
  },
  SET_TREE_DATA(state, treeData) {
    state.treeData = treeData;
  },
  SET_TREE_DATA_MAP(state, treeDataMap) {
    state.treeDataMap = treeDataMap;
  },
  PUSH_SCENE_LIST(state, scene) {
    state.sceneList.unshift(scene)
  },
  SET_SCENE_LIST(state, list) {
    state.sceneList = list;
  },
  SET_SCENE_INFO(state, scene) {
    state.checkSceneInfo = scene
  },
  REVERSE_SHOW_SCENE_EDIT(state, status) {
    state.showSceneEdit = status
  },
  SET_3D_EDITOR_STATUS(state, status) {
    state.show3dEditor = status;
  },
  SET_DRAW_STATUS(state, status) {
    state.showSceneListDrawer = status;
  },
  SET_EDITOR_CHOOSE_MODEL_ARR(state, arr) {
    state.editorChooseModelArr = [].concat(arr);
  },
  SET_CAMERA_POSITION_LIST(state, list) {
    state.cameraPositionList = [].concat(list);
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
